"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.surveys = exports.slideshow = exports.qa = exports.polls = exports.hasScreen = void 0;
/** 
 * These structures serve to clear out singleton component data
 * Not to be confused with actual component event data structures
 **/

var polls = exports.polls = function polls() {
  return {
    isActivePollId: "",
    pollsCollection: {}
  };
};
var qa = exports.qa = function qa() {
  return {
    questions: {},
    folders: {}
  };
};
var surveys = exports.surveys = function surveys() {
  return {
    activeSurveyId: '',
    audiencePageId: '',
    surveysCollection: {},
    submissions: {}
  };
};
var slideshow = exports.slideshow = function slideshow() {
  return {
    pdfURL: '',
    fileName: '',
    currentIndex: 0,
    isUploading: false,
    ratio: {}
  };
};

/**
 * Central place to get screen id. If for some reason the payload structure for component
 * events change, this should be the only place we need to come to
 *
 **/
var hasScreen = exports.hasScreen = function hasScreen(componentEvent, id) {
  if (componentEvent.hasOwnProperty("screenId")) {
    if (componentEvent.screenId.indexOf(id) !== -1) {
      return true;
    }
  }
  return false;
};